

export class ManuManagement {
  public id: string;
  public manuManagementId: number;
  public name: string;
  public url: string;
  public target: string;
  public manuType: string;
  public sortOrder: number;
  public isActive: boolean;
  public createdDate: Date;
  public updatedDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/models/manu-management/manu-management-model.ts